
import Vue from 'vue';
import { Component, InjectReactive } from 'vue-property-decorator';
import CPOpenAccountFormSubsection from '../open-account/form/CPOpenAccountFormSubsection.vue';
import { PlannedInvestmentFrequency, PlannedInvestmentVolume } from '@/store/dueDiligence/types';
import CPRadioGroup from '../open-account/input/CPRadioGroup.vue';
import * as DueDiligenceConstants from '@/store/dueDiligence/constants';
import { CPTextInput } from '@capital-platforms/cpui';

@Component({
    components: {
        CPOpenAccountFormSubsection,
        CPRadioGroup,
        CPTextInput,
    },
})
export default class CPDueDiligencePlannedInvestmentVolume extends Vue {
    @InjectReactive()
    public readonly viewOnly!: boolean;

    public readonly investmentVolumeOptions = DueDiligenceConstants.PlannedInvestmentVolumeOptions;
    public readonly investmentFrequencyOptions = DueDiligenceConstants.PlannedInvestmentFrequencyOptions;

    get showInvestmentFrequencyOther(): boolean {
        return this.investmentFrequency === DueDiligenceConstants.PlannedInvestmentFrequency.Others;
    }

    get investmentFrequency(): PlannedInvestmentFrequency | null {
        return this.$store.state.dueDiligence.details.GeneralDetails.PlannedInvestmentDetails.PlannedInvestmentFrequency;
    }

    set investmentFrequency(value: PlannedInvestmentFrequency | null) {
        this.$store.commit('dueDiligence/setPlannedInvestmentFrequency', value);
    }

    get investmentFrequencyOther(): string | null {
        return this.$store.state.dueDiligence.details.GeneralDetails.PlannedInvestmentDetails.PlannedInvestmentFrequencyOther;
    }

    set investmentFrequencyOther(value: string | null) {
        this.$store.commit('dueDiligence/setPlannedInvestmentFrequencyOther', value);
    }
    get investmentVolume(): PlannedInvestmentVolume | null {
        return this.$store.state.dueDiligence.details.GeneralDetails.PlannedInvestmentDetails.PlannedInvestmentVolume;
    }

    set investmentVolume(val: PlannedInvestmentVolume) {
        this.$store.commit('dueDiligence/setPlannedInvestmentVolume', val);
    }
}
